import { Directive, input } from '@angular/core';

interface MultiSelectOptionTemplateContext<T extends object | string> {
  $implicit: T;
  index: number;
  disabled: boolean;
}

@Directive({
  selector: 'ng-template[pluginsMultiSelectOption]',
  standalone: true,
})
export class MultiSelectOptionDirective<T extends object | string> {
  readonly options = input.required<T[]>({ alias: 'pluginsMultiSelectOption' });

  static ngTemplateContextGuard<U extends object | string>(
    dir: MultiSelectOptionDirective<U>,
    ctx: unknown,
  ): ctx is MultiSelectOptionTemplateContext<U> {
    return true;
  }
}
